// extracted by mini-css-extract-plugin
export default {"container":"document-subtitle_container__1rmsY"};